import {
  BatteryFull,
  DeveloperBoard,
  MobileScreenShareRounded,
  Settings,
  SettingsAccessibility,
  Web,
} from "@mui/icons-material";
import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";

const services = [
  {
    heading: "School Management Platform",
    desc: "An intelligent, centralized system to automate attendance, grading, timetables, and academic reporting with complete operational visibility.",
    icon: <BatteryFull sx={{ fontSize: 26 }} />,
    gradient: "linear-gradient(135deg, #4F6EF7 0%, #7C3AED 100%)",
    glow: "rgba(79,110,247,0.28)",
  },
  {
    heading: "Parent Engagement App",
    desc: "Real-time communication and updates that strengthen parent-school collaboration and build transparency in academic progress.",
    icon: <Settings sx={{ fontSize: 26 }} />,
    gradient: "linear-gradient(135deg, #0EA5E9 0%, #4F6EF7 100%)",
    glow: "rgba(14,165,233,0.28)",
  },
  {
    heading: "AI-Powered Tutor",
    desc: "24/7 personalized academic assistance delivering structured explanations, concept clarity, and performance-driven insights.",
    icon: <SettingsAccessibility sx={{ fontSize: 26 }} />,
    gradient: "linear-gradient(135deg, #10B981 0%, #0EA5E9 100%)",
    glow: "rgba(16,185,129,0.28)",
  },
  {
    heading: "Gamified Learning Engine",
    desc: "Interactive quizzes and achievement systems that boost engagement, improve retention, and drive measurable academic outcomes.",
    icon: <Web sx={{ fontSize: 26 }} />,
    gradient: "linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)",
    glow: "rgba(245,158,11,0.28)",
  },
  {
    heading: "Unified Communication Hub",
    desc: "Instant notifications, announcements, and structured messaging to streamline collaboration between staff, parents, and students.",
    icon: <MobileScreenShareRounded sx={{ fontSize: 26 }} />,
    gradient: "linear-gradient(135deg, #EC4899 0%, #7C3AED 100%)",
    glow: "rgba(236,72,153,0.28)",
  },
  {
    heading: "Smart Fee & Billing System",
    desc: "Automated invoicing, payment tracking, and financial transparency powered by secure cloud infrastructure.",
    icon: <DeveloperBoard sx={{ fontSize: 26 }} />,
    gradient: "linear-gradient(135deg, #4F6EF7 0%, #10B981 100%)",
    glow: "rgba(79,110,247,0.28)",
  },
];

const OurServices = () => {
  return (
    <Box sx={{ py: { xs: 10, md: 14 }, bgcolor: "#F8FAFF" }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box textAlign="center" mb={{ xs: 8, md: 10 }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.8,
              borderRadius: "100px",
              bgcolor: "rgba(79,110,247,0.08)",
              border: "1px solid rgba(79,110,247,0.2)",
              mb: 3,
            }}
          >
            <Typography fontSize="0.82rem" fontWeight={600} color="#4F6EF7" letterSpacing="0.04em">
              OUR SOLUTIONS
            </Typography>
          </Box>

          <Typography
            variant="h2"
            fontWeight={900}
            color="#0D1B4B"
            gutterBottom
            sx={{ fontSize: { xs: "1.8rem", md: "2.8rem" }, mb: 2 }}
          >
            Powerful Solutions for
            <br />
            Modern Education
          </Typography>

          <Typography
            variant="h6"
            color="#64748B"
            sx={{ maxWidth: 720, mx: "auto", lineHeight: 1.8, fontWeight: 400 }}
          >
            MySchoolling combines enterprise-grade school management,
            AI-powered learning tools, and seamless communication systems
            into one intelligent ecosystem.
          </Typography>
        </Box>

        {/* Services grid */}
        <Grid container spacing={3}>
          {services.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  p: { xs: 4, md: 4.5 },
                  borderRadius: "22px",
                  height: "100%",
                  bgcolor: "#fff",
                  border: "1.5px solid rgba(13,27,75,0.07)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2.5,
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: `0 24px 64px ${item.glow}`,
                    borderColor: "rgba(79,110,247,0.15)",
                  },
                }}
              >
                {/* Top-right glow */}
                <Box
                  sx={{
                    position: "absolute",
                    top: -30,
                    right: -30,
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    background: item.gradient,
                    opacity: 0.06,
                    filter: "blur(16px)",
                    pointerEvents: "none",
                  }}
                />

                {/* Icon */}
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: item.gradient,
                    color: "#fff",
                    boxShadow: `0 8px 20px ${item.glow}`,
                    flexShrink: 0,
                  }}
                >
                  {item.icon}
                </Box>

                <Typography variant="h6" fontWeight={700} color="#0D1B4B">
                  {item.heading}
                </Typography>

                <Typography variant="body2" color="#475569" sx={{ lineHeight: 1.8, fontSize: "0.92rem" }}>
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurServices;
